import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "disabledDescription", "isSelected", "isHighlighted", "readOnly", "isDisabled", "width", "height", "onClick", "flow", "allExtensionDefinitionsQuery", "isUngated", "borderStyle", "overrideAccentColor"];
import { Component } from 'react';
import { generatePath, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import { getActionById, getObjectTypeId, getSourceApp as getFlowSourceApp, getActionHeaderTitle } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { getEdgeIdFromGoToActionId, getPreviousActionId } from 'automation-ui-action-features/records/recordsUtils';
import { wireUpdateActionAndSaveFlow, defaultErrorHandlingForUpdateFlow } from 'automation-ui-canvas/queries/flowQueries';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { getSourceApp } from 'automation-ui-canvas/selectors/embedSelectors';
import EditActionButton from 'automation-ui-canvas/components/action-card-options/EditActionButton';
import GoToActionCard from 'automation-ui-action-features/actions/go-to/GoToActionCard';
import { queryAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { GO_TO_ACTION_EDITOR, FLOW_VIEW_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import { buildSearchStringWithCurrentSourceFields } from 'automation-ui-canvas/utils/routingUtils';
import { DeleteIcon } from 'foundations-assets';
import { GO_TO_ACTION_FLOW_VIEW_TEST } from 'automation-ui-canvas/constants/Gates';
import { GO_TO_ACTION_FLOW_VIEW } from 'automation-ui-canvas/containers/flow-views/flowViewIds';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  readOnly: false,
  isSelected: false
};
class GoToActionCardWrapper extends Component {
  constructor(...args) {
    super(...args);
    this.getPreviousAction = () => {
      const {
        actionId,
        flow
      } = this.props;
      const previousActionId = getPreviousActionId(actionId);
      return getActionById(flow, previousActionId);
    };
    this.getNextAction = () => {
      const {
        flow,
        actionId
      } = this.props;
      const previousAction = this.getPreviousAction();
      if (!previousAction || !previousAction.getConnection()) {
        return null;
      }
      let nextAction = null;
      const edgeId = getEdgeIdFromGoToActionId(actionId);
      const connection = previousAction.getConnection();
      const connector = connection.getConnectorByEdgeId(edgeId);
      const nextActionId = connector.getNextActionId();
      if (nextActionId) {
        nextAction = getActionById(flow, Number(nextActionId));
      }
      return nextAction;
    };
    this.handleEditAction = () => {
      const {
        flow,
        history,
        flowId,
        actionId,
        isUngated
      } = this.props;
      const {
        usageTracker
      } = this.context;
      trackEvent(usageTracker, Trackables.INTERACT_WITH_GO_TO_ACTION, {
        interactionType: 'change',
        objectTypeId: getObjectTypeId(flow)
      });
      if (isUngated(GO_TO_ACTION_FLOW_VIEW_TEST)) {
        const pathname = generatePath(FLOW_VIEW_ROOT, {
          flowId: flowId,
          viewId: GO_TO_ACTION_FLOW_VIEW
        });
        history.replace({
          pathname,
          search: `?edgeId=${actionId}`
        });
      } else {
        const screen = getScreenForFlowType(flow.flowType);
        const pathname = generatePath(GO_TO_ACTION_EDITOR, {
          flowId: flowId,
          screen,
          actionId
        });
        history.replace({
          pathname,
          search: buildSearchStringWithCurrentSourceFields({
            location: history.location,
            queryParams: {
              updateConnection: true
            }
          })
        });
      }
    };
    this.handleDeleteAction = () => {
      const {
        actionId,
        flow,
        sourceApp,
        updateActionAndSaveFlow,
        dispatch
      } = this.props;
      const {
        usageTracker
      } = this.context;
      trackEvent(usageTracker, Trackables.INTERACT_WITH_GO_TO_ACTION, {
        interactionType: 'delete',
        objectTypeId: getObjectTypeId(flow)
      });
      const edgeId = getEdgeIdFromGoToActionId(actionId || '');
      const previousAction = this.getPreviousAction();
      updateActionAndSaveFlow({
        action: previousAction.removeEdgeFromConnection(edgeId),
        edgeId,
        flow,
        sourceApp
      }).catch(error => defaultErrorHandlingForUpdateFlow({
        error,
        dispatch
      }));
    };
    this.renderTitleAction = () => /*#__PURE__*/_jsx(EditActionButton, {
      IconAsset: DeleteIcon,
      defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.editActionDropdown.delete"
      }),
      options: [{
        label: '',
        onClick: event => {
          event.stopPropagation();
          this.handleDeleteAction();
        }
      }]
    });
  }
  render() {
    var _allExtensionDefiniti, _allExtensionDefiniti2;
    const _this$props = this.props,
      {
        actionId,
        disabledDescription,
        isSelected,
        isHighlighted,
        readOnly,
        isDisabled,
        width,
        height,
        onClick,
        flow,
        allExtensionDefinitionsQuery,
        isUngated,
        borderStyle,
        overrideAccentColor
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};
    return /*#__PURE__*/_jsx(GoToActionCard, Object.assign({}, rest, {
      isDisabled: isDisabled,
      actionId: actionId,
      disabledDescription: disabledDescription,
      isSelected: isSelected,
      isHighlighted: isHighlighted,
      readOnly: readOnly,
      onEditAction: this.handleEditAction,
      getNextAction: this.getNextAction,
      width: width,
      height: height,
      onClick: onClick,
      TitleAction: !readOnly && !isDisabled ? this.renderTitleAction : undefined,
      getHeaderTitle: getActionHeaderTitle({
        flow,
        extensionDefinitions,
        isUngated
      }),
      borderStyle: borderStyle,
      overrideAccentColor: overrideAccentColor
    }));
  }
}
GoToActionCardWrapper.defaultProps = defaultProps;
GoToActionCardWrapper.contextType = UsageTrackerContext;
export default compose(withRouter, connect((state, {
  flow
}) => {
  return {
    flowObjectTypeId: getObjectTypeId(flow),
    flowSourceApp: getFlowSourceApp(flow) || undefined,
    sourceApp: getSourceApp(state)
  };
}, dispatch => ({
  dispatch
})), wireUpdateActionAndSaveFlow, queryAllExtensionDefinitions, wireAuthConsumer)(GoToActionCardWrapper);